"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var form_control_service_1 = require("../../services/form-control.service");
var pre_chat_service_1 = require("../../services/pre-chat.service");
var ng_recaptcha_1 = require("ng-recaptcha");
var chat_type_model_1 = require("../../models/chat-type-model");
var log_event_type_model_1 = require("../../models/log-event-type.model");
var FormComponent = /** @class */ (function () {
    function FormComponent(preChatService, formControlService) {
        this.preChatService = preChatService;
        this.formControlService = formControlService;
        this.chatFormSubmitted = new core_1.EventEmitter();
        this.reCaptchaFormControlName = 'reCaptcha';
        this.formSubmitted = false;
        this.documentReferrer = model.referrer;
        this.recaptchaResponse = '';
        this.overriddenSkillAddresses = model.overriddenSkillAddresses;
        this.targetSkillAddress = model.targetSkillAddress;
    }
    /*
    * Return true if proactive is enabled and has same form loaded as mentioned in _uwc('use-rule') command
    * Return true if proactive form is disabled
    * Return false if formTag is set to null for Reactive
    * Return false if formTag is set to null for Proactive
    * Return true for an incorrect formTag for Proactive
    */
    FormComponent.prototype.isActiveFormValid = function () {
        if (this.settings.formType === chat_type_model_1.CHAT_TYPE.REACTIVE && this.settings.formTag !== null) {
            return true;
        }
        if (this.settings.formType === chat_type_model_1.CHAT_TYPE.PROACTIVE) {
            if (this.settings.formTag === null)
                return false;
            if (this.settings.formTag !== this.settings.form.tag)
                return true;
            if (this.settings.formTag === this.settings.form.tag)
                return true;
        }
        return false;
    };
    FormComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.formSettings(this.settings.form);
        this.customParams$ = this.preChatService.bindToMessageEvents();
        this.acceptInvitationSubscription = this.preChatService.invitationAccepted$.subscribe(function (invitationAccepted) {
            if (invitationAccepted) {
                if (!_this.isActiveFormValid()) {
                    _this.submitForm();
                }
                else {
                    _this.logProactiveEvent(log_event_type_model_1.LogEventType.ChatFormOffer);
                    _this.preChatService.showPreChatFormForProactive();
                }
            }
        });
        this.reactiveFormSubmitSubscription = this.preChatService.reactiveFormSubmit$.subscribe(function (submit) {
            if (submit && !_this.isActiveFormValid()) {
                _this.submitForm();
            }
        });
    };
    FormComponent.prototype.formSettings = function (activeForm) {
        this.activeForm = activeForm;
        if (!this.isActiveFormValid()) {
            this.form = this.formControlService.toFormGroup([]);
            return;
        }
        this.form = this.formControlService.toFormGroup(activeForm.rows);
        if (this.reCaptchaEnabled) {
            this.formControlService.addFormControl(this.form, this.reCaptchaFormControlName, false);
        }
    };
    FormComponent.prototype.ngAfterViewInit = function () {
        if (this.captchaRef)
            this.captchaRef.reset();
    };
    FormComponent.prototype.reCaptchaResponseCallback = function (captchaResponse) {
        this.recaptchaResponse = captchaResponse;
        this.submitForm();
    };
    FormComponent.prototype.submitForm = function () {
        if (this.settings.formType === chat_type_model_1.CHAT_TYPE.PROACTIVE && this.settings.formTag === this.settings.form.tag) {
            //If the above mentioned conditions are true. then Proactive chat has a valid form
            // and submitForm() will be invoke only on clicking of chat form submit button, hence the log
            this.logProactiveEvent(log_event_type_model_1.LogEventType.ChatFormSubmit);
        }
        var prechatElement = this.preChatForm.nativeElement;
        prechatElement.submit();
        this.formSubmitted = true;
        this.chatFormSubmitted.emit(true);
        this.preChatService.setFormSubmitted();
        this.preChatService.updateChatState();
    };
    FormComponent.prototype.onSubmit = function (event) {
        if (this.reCaptchaEnabled) {
            this.captchaRef.execute();
        }
        else {
            this.submitForm();
        }
    };
    FormComponent.prototype.logProactiveEvent = function (logEvent) {
        if (this.settings.formType !== chat_type_model_1.CHAT_TYPE.PROACTIVE) {
            return;
        }
        this.preChatService.logEvent(logEvent, log_event_type_model_1.LogEventType[logEvent]);
    };
    FormComponent.prototype.ngOnDestroy = function () {
        if (this.acceptInvitationSubscription) {
            this.acceptInvitationSubscription.unsubscribe();
        }
        if (this.reactiveFormSubmitSubscription) {
            this.reactiveFormSubmitSubscription.unsubscribe();
        }
    };
    return FormComponent;
}());
exports.FormComponent = FormComponent;
